var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.500122C12.8284 0.500122 13.5 1.17169 13.5 2.00012V7.50012H10.5V2.00012C10.5 1.17169 11.1716 0.500122 12 0.500122ZM28 0.500122C28.8284 0.500122 29.5 1.17169 29.5 2.00012V7.50012H26.5V2.00012C26.5 1.17169 27.1716 0.500122 28 0.500122ZM3.5 12.0001C3.5 11.1717 4.17157 10.5001 5 10.5001H35C35.8284 10.5001 36.5 11.1717 36.5 12.0001C36.5 12.8285 35.8284 13.5001 35 13.5001H32.5V19.0001C32.5 25.396 27.6963 30.67 21.5 31.411V38.0001C21.5 38.8285 20.8284 39.5001 20 39.5001C19.1716 39.5001 18.5 38.8285 18.5 38.0001V31.411C12.3037 30.67 7.5 25.396 7.5 19.0001V13.5001H5C4.17157 13.5001 3.5 12.8285 3.5 12.0001ZM10.5 13.5001V19.0001C10.5 24.2468 14.7533 28.5001 20 28.5001C25.2467 28.5001 29.5 24.2468 29.5 19.0001V13.5001H10.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.d463472e3d925cf8c2a218a8f7d52c58.svg";
export { ForwardRef as ReactComponent };